import { track } from '@vercel/analytics';

// Custom analytics events for better insights
export const trackEvent = {
  // Project interactions
  projectView: (projectName: string) => {
    track('project_view', { project: projectName });
  },
  
  projectDemo: (projectName: string) => {
    track('project_demo_click', { project: projectName });
  },
  
  // Contact interactions
  contactFormSubmit: () => {
    track('contact_form_submit');
  },
  
  emailClick: () => {
    track('email_click');
  },
  
  phoneClick: () => {
    track('phone_click');
  },
  
  // Social media clicks
  socialClick: (platform: string) => {
    track('social_click', { platform });
  },
  
  // Terminal interactions
  terminalCommand: (command: string) => {
    track('terminal_command', { command });
  },
  
  // Navigation
  sectionView: (section: string) => {
    track('section_view', { section });
  },
  
  // Skills interaction
  skillsView: () => {
    track('skills_section_view');
  },
  
  // Certificate interactions
  certificateView: (certificate: string) => {
    track('certificate_view', { certificate });
  }
};